import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CommonService } from 'src/app/shared/services/common.service';
import { ApplicationConfigService } from '../config/application-config.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class TempRequestService {
  protected resourceUrl;

  constructor(
    protected http: HttpClient,
    protected commonService: CommonService,
    protected applicationConfigService: ApplicationConfigService,
  ) {
    this.resourceUrl = this.applicationConfigService.getEndpointFor('account-portal/workflow');
  }

  query(q: any): Observable<any> {
    const options: any = this.commonService.toQueryString(q);
    return this.http.get<any>(`${this.resourceUrl}/temp/request?${options}`);
  }

  queryRejectList(q: any): Observable<any> {
    const options: any = this.commonService.toQueryString(q);
    return this.http.get<any>(`${this.resourceUrl}/temp/reject/request?${options}`);
  }

  myWorkflowList(q: any): Observable<any> {
    const options: any = this.commonService.toQueryString(q);
    return this.http.get<any>(`${this.resourceUrl}/temp/request/my?${options}`);
  }

  makeRequest(payload: any): Observable<any> {
    return this.http.post<any>(`${this.resourceUrl}/request/make`, payload, { observe: 'response' });
  }

  checkRequest(id: any, status: any, remarks?: any): Observable<any> {
    const payload = {
      id,
      status,
      remarks,
    };
    return this.http.post<any>(`${this.resourceUrl}/request/check`, payload, { observe: 'response' });
  }

  compareChanges(previousData: any, updatedData: any) {
    let availableKeys = Object.keys(previousData);
    let rowKeys = Object.keys(updatedData);
    let matchingRowKeys = availableKeys.filter((k) => rowKeys.indexOf(k) > -1);
    let changes = '';
    let havaChanges = false;
    matchingRowKeys.forEach((rk) => {
      if (updatedData[rk] !== previousData[rk]) {
        havaChanges = true;
        //matching value
        changes += ' ' + rk + ' = "' + previousData[rk] + '" to "' + updatedData[rk] + '",';
      }
    });
    if (havaChanges) changes = 'Following data has been changed:' + changes;
    else changes = 'No change has been done,';
    changes = changes.slice(0, -1);

    return changes;
  }

  compareChangesInArray(
    fieldName: any,
    keyField: any,
    previousDataArray: any[],
    updatedDataArray: any[],
    haveChangesBefore: boolean,
  ): string {
    const changeDetails: string[] = [];
    let haveChanges = false;

    for (let i = 0; i < previousDataArray.length; i++) {
      const previousData = previousDataArray[i];
      const updatedData = updatedDataArray[i];

      // Compare keys present in both objects
      const commonKeys = Object.keys(previousData).filter((key) => updatedData?.hasOwnProperty(key));

      commonKeys.forEach((key) => {
        if (updatedData[key] != previousData[key]) {
          haveChanges = true;
          changeDetails.push(
            `${key} of ${updatedData[keyField]} = ${JSON.stringify(previousData[key])} to ${JSON.stringify(
              updatedData[key],
            )}`,
          );
        }
      });
    }

    let changes = '';

    if (haveChanges) {
      changes = changeDetails.join(', ');
      if (!haveChangesBefore) {
        changes = `Following data has been changed: ${fieldName} = [${changes}]`;
      } else {
        changes = `, ${fieldName} = [${changes}]`;
      }
    } else {
      if (!haveChangesBefore) {
        changes = 'No change has been done';
      }
    }

    return changes;
  }

  compareChangesInArrayForMenuPermission(
    fieldName: any,
    keyField: any,
    previousDataArray: any[],
    updatedDataArray: any[],
    haveChangesBefore: boolean,
  ): string {
    const changeDetails: string[] = [];
    let haveChanges = false;

    const compareMenus = (previousMenu: any, updatedMenu: any) => {
      const commonKeys = Object.keys(previousMenu).filter((key) => updatedMenu?.hasOwnProperty(key));

      commonKeys.forEach((key) => {
        if (Array.isArray(previousMenu[key])) {
          if (key === 'menuResponses') {
            for (let i = 0; i < previousMenu[key].length; i++) {
              compareMenus(previousMenu[key][i], updatedMenu[key][i]);
            }
          } else {
            compareMenus(previousMenu[key], updatedMenu[key]);
          }
        } else if (updatedMenu[key] !== previousMenu[key]) {
          haveChanges = true;
          changeDetails.push(
            `${updatedMenu[keyField]} = ${JSON.stringify(previousMenu[key])} to ${JSON.stringify(updatedMenu[key])}`,
          );
        }
      });
    };

    for (let i = 0; i < previousDataArray.length; i++) {
      const previousData = previousDataArray[i];
      const updatedData = updatedDataArray[i];

      compareMenus(previousData, updatedData);
    }

    let changes = '';

    if (haveChanges) {
      changes = changeDetails.join(', ');
      if (!haveChangesBefore) {
        changes = `Following data has been changed:  ${changes}`;
      } else {
        changes = `, ${fieldName} = [${changes}]`;
      }
    } else {
      if (!haveChangesBefore) {
        changes = 'No change has been done';
      }
    }

    return changes;
  }

  formatImageUrl(path: string) {
    if (path?.startsWith('/api/v1')) {
      return environment.baseUrl + path;
    }
    return path;
  }
}
